import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { UserService } from '../../service/user.service';

/**
 * Generated class for the PlaylistNewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-playlist-new',
  templateUrl: 'playlist-new.html',
})
export class PlaylistNewPage {

  public title;

  constructor(public navCtrl: NavController, public navParams: NavParams, private us: UserService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PlaylistNewPage');
  }

  save(){

    this.us.setPlaylistTitle(0, this.title);
    this.navCtrl.pop();

  }

}



// WEBPACK FOOTER //
// ./src/pages/playlist-new/playlist-new.ts